import { useTranslation } from 'react-i18next';

import { Icon } from '~/components/Icon';
import { Tooltip } from '~/components/Tooltip';

import type { Role } from '../api/lib/schemas';
import { RoleMap } from '../constants/RoleMap';

export function UserRole({ roles = [] }: { roles: Role[] }) {
  const { t } = useTranslation('settings', { keyPrefix: 'roles' });

  if (!roles.length || !RoleMap[roles[0]]) {
    return null;
  }

  const [shownRole, ...additionalRoles] = roles;

  const multiRoleTooltip = (
    <ul className="m-0 max-h-[13rem] list-none space-y-md overflow-auto">
      {additionalRoles.map((r: Role) => {
        const { name, description } = RoleMap[r];

        return (
          <li key={r}>
            <h3 className="font-bold">{t(name)}</h3>
            <p>{t(description)}</p>
          </li>
        );
      })}
    </ul>
  );

  const { name, description } = RoleMap[shownRole];

  return (
    <span>
      {t(name)}
      <Tooltip content={t(description)} side="top" delayDuration={0}>
        <Icon
          type="circle-info"
          variant="light"
          className="ml-sm text-subtlest"
          size="sm"
        />
      </Tooltip>
      {additionalRoles.length ? (
        <Tooltip content={multiRoleTooltip} side="top" delayDuration={0}>
          <span className="ml-md basis-md rounded-xs border px-sm py-xs text-center text-body-xs leading-5 bg-level-05 border-emphasis-subtle">
            +{additionalRoles.length}
          </span>
        </Tooltip>
      ) : null}
    </span>
  );
}

UserRole.displayName = 'UserRole';
